import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const BankFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M19.48 18.77H4.12c-.55 0-1 .45-1 1s.45 1 1 1h15.35c.55 0 1-.45 1-1s-.45-1-1-1h.01ZM4.29 10.17h1.98v5.73h-1.1c-.55 0-1 .45-1 1s.45 1 1 1h13.64c.55 0 1-.45 1-1s-.45-1-1-1h-.98v-5.41c0-.11-.03-.22-.06-.32h1.8c1.04 0 1.47-1.17.64-1.72l-2.82-1.84-4.82-3.15c-.38-.25-.89-.25-1.27 0L6.48 6.61 3.66 8.45c-.83.54-.4 1.72.64 1.72h-.01Zm11.61 0c-.03.1-.06.2-.06.32v5.41H13v-5.73h2.91-.01Zm-4.91 0v5.73H8.27v-5.73h2.72Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default BankFilled
